import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { StorageService } from '../services/storage.service';

export const superAdminGuard: CanActivateFn = (route, state) => {
  const storage = inject(StorageService);
  const router = inject(Router);

  const role = storage.getItem('role');

  if (role === 'super_admin') {
    return true;
  }

  // Not a super admin, redirect to organization workspace
  router.navigate(['/workspace']);
  return false;
};
